(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  /*
   * FAQ accordion behaviour.
   * Uses Shopify's {% javascript %} block (auto-deduplicated to ONE file
   * regardless of how many instances of this section live on the page).
   *
   * Click handling uses DOCUMENT-LEVEL event delegation, so newly-added
   * <faq-item> elements (whether from page load or Section Rendering API
   * morphs) just work — no per-instance listener wiring required.
   */
  (function () {
    if (window.__faqAccordionInit) return;
    window.__faqAccordionInit = true;

    /* ───── Helpers ────────────────────────────────────────────── */
    function isOpen(item)  { return item.hasAttribute('open'); }
    function openItem(item) {
      if (isOpen(item)) return;
      item.setAttribute('open', '');
      item.querySelector('.faq__q')?.setAttribute('aria-expanded', 'true');
    }
    function closeItem(item) {
      if (!isOpen(item)) return;
      item.removeAttribute('open');
      item.querySelector('.faq__q')?.setAttribute('aria-expanded', 'false');
    }
    function toggleItem(item) {
      if (isOpen(item)) {
        closeItem(item);
        return;
      }
      // Single-open mode: close siblings within the same accordion.
      const parent = item.closest('faq-accordion');
      if (parent && parent.dataset.singleOpen === 'true') {
        parent.querySelectorAll('faq-item[open]').forEach((sibling) => {
          if (sibling !== item) closeItem(sibling);
        });
      }
      openItem(item);
    }

    /* ───── Click delegation (works for every FAQ item on the page) ─ */
    document.addEventListener('click', (event) => {
      const button = event.target.closest('.faq__q');
      if (!button) return;
      const item = button.closest('faq-item');
      if (!item) return;
      event.preventDefault();
      toggleItem(item);
    });

    /* ───── Enforce single-open on initial render ─────────────────── */
    function enforceInitialState(root) {
      (root || document).querySelectorAll('faq-accordion[data-single-open="true"]').forEach((acc) => {
        const opens = acc.querySelectorAll('faq-item[open]');
        for (let i = 1; i < opens.length; i++) closeItem(opens[i]);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => enforceInitialState());
    } else {
      enforceInitialState();
    }

    /* ───── Custom element definitions (idempotent + safe) ────────── */
    if (!window.customElements.get('faq-item')) {
      class FaqItem extends HTMLElement {
        get isOpen() { return isOpen(this); }
        open()  { openItem(this); }
        close() { closeItem(this); }
        toggle() { toggleItem(this); }
      }
      window.customElements.define('faq-item', FaqItem);
    }
    if (!window.customElements.get('faq-accordion')) {
      class FaqAccordion extends HTMLElement {
        connectedCallback() { enforceInitialState(this); }
      }
      window.customElements.define('faq-accordion', FaqAccordion);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milestones-slider"] && !Shopify.designMode) return;
  try {
    
  /*
   * Milestones slider — multi-instance safe via document delegation.
   * Each slider's prev/next buttons scroll its own track. New instances
   * added via Section Rendering API work immediately (no rewiring).
   *
   * Also updates [data-disabled] on the prev/next buttons when the track
   * is at its scroll start / end so the arrows fade out at the boundaries.
   */
  (function () {
    if (window.__milestoneSliderInit) return;
    window.__milestoneSliderInit = true;

    function slideStep(track) {
      const slide = track.querySelector('.cmsl__slide');
      if (!slide) return 0;
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return slide.offsetWidth + gap;
    }

    function updateDisabled(section) {
      const track = section.querySelector('[data-cmsl-track]');
      if (!track) return;
      const atStart = track.scrollLeft <= 1;
      const atEnd   = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      section.querySelectorAll('[data-cmsl-prev]').forEach(b => b.dataset.disabled = atStart ? 'true' : 'false');
      section.querySelectorAll('[data-cmsl-next]').forEach(b => b.dataset.disabled = atEnd   ? 'true' : 'false');
    }

    /* Click delegation */
    document.addEventListener('click', (event) => {
      const prev = event.target.closest('[data-cmsl-prev]');
      const next = event.target.closest('[data-cmsl-next]');
      const btn = prev || next;
      if (!btn || btn.dataset.disabled === 'true') return;
      const section = btn.closest('.cmsl');
      const track = section?.querySelector('[data-cmsl-track]');
      if (!track) return;
      const step = slideStep(track);
      track.scrollBy({ left: prev ? -step : step, behavior: 'smooth' });
    });

    /* Wire scroll listeners + initial disabled state for each slider */
    function wireSection(section) {
      if (section._cmslWired) return;
      section._cmslWired = true;
      const track = section.querySelector('[data-cmsl-track]');
      if (!track) return;
      let ticking = false;
      track.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          updateDisabled(section);
          ticking = false;
        });
      }, { passive: true });
      window.addEventListener('resize', () => updateDisabled(section));
      updateDisabled(section);
    }

    function wireAll() {
      document.querySelectorAll('.cmsl').forEach(wireSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', wireAll);
    } else {
      wireAll();
    }
    /* Re-wire newly added sliders (e.g. via Section Rendering API morphs). */
    new MutationObserver(wireAll).observe(document.body, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["process-timeline-slider"] && !Shopify.designMode) return;
  try {
    
  /*
   * Process timeline slider — multi-instance safe via document delegation.
   */
  (function () {
    if (window.__ptslInit) return;
    window.__ptslInit = true;

    function slideStep(track) {
      const slide = track.querySelector('.ptsl__step');
      if (!slide) return 0;
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return slide.offsetWidth + gap;
    }

    function updateDisabled(section) {
      const track = section.querySelector('[data-ptsl-track]');
      if (!track) return;
      const atStart = track.scrollLeft <= 1;
      const atEnd   = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      section.querySelectorAll('[data-ptsl-prev]').forEach(b => b.dataset.disabled = atStart ? 'true' : 'false');
      section.querySelectorAll('[data-ptsl-next]').forEach(b => b.dataset.disabled = atEnd   ? 'true' : 'false');
    }

    document.addEventListener('click', (event) => {
      const prev = event.target.closest('[data-ptsl-prev]');
      const next = event.target.closest('[data-ptsl-next]');
      const btn = prev || next;
      if (!btn || btn.dataset.disabled === 'true') return;
      const section = btn.closest('.ptsl');
      const track = section?.querySelector('[data-ptsl-track]');
      if (!track) return;
      track.scrollBy({ left: prev ? -slideStep(track) : slideStep(track), behavior: 'smooth' });
    });

    function wire(section) {
      if (section._ptslWired) return;
      section._ptslWired = true;
      const track = section.querySelector('[data-ptsl-track]');
      if (!track) return;
      let ticking = false;
      track.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => { updateDisabled(section); ticking = false; });
      }, { passive: true });
      window.addEventListener('resize', () => updateDisabled(section));
      updateDisabled(section);
    }
    function wireAll() { document.querySelectorAll('.ptsl').forEach(wire); }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', wireAll);
    } else {
      wireAll();
    }
    new MutationObserver(wireAll).observe(document.body, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats-with-image"] && !Shopify.designMode) return;
  try {
    
  /*
   * Counter animation: when the section enters the viewport, each
   * number with data-counter animates from 0 up to the target.
   * Multi-instance safe via document.querySelectorAll on every wireAll.
   */
  (function () {
    if (window.__fstatsCounterInit) return;
    window.__fstatsCounterInit = true;

    function animate(el, target, duration) {
      const startTs = performance.now();
      const prefix = el.dataset.counterPrefix || '';
      const suffix = el.dataset.counterSuffix || '';
      function frame(now) {
        const elapsed = now - startTs;
        const t = Math.min(elapsed / duration, 1);
        // easeOutCubic
        const eased = 1 - Math.pow(1 - t, 3);
        const current = Math.floor(target * eased);
        el.textContent = prefix + current.toLocaleString() + suffix;
        if (t < 1) {
          requestAnimationFrame(frame);
        } else {
          el.textContent = prefix + target.toLocaleString() + suffix;
        }
      }
      requestAnimationFrame(frame);
    }

    function activate(section) {
      const duration = Number(section.dataset.counterDuration) || 2000;
      section.querySelectorAll('[data-counter]').forEach((el) => {
        if (el.dataset.animated) return;
        const target = parseInt(String(el.dataset.counter).replace(/[^\d-]/g, ''), 10);
        if (!isFinite(target)) return;
        el.dataset.animated = 'true';
        animate(el, target, duration);
      });
    }

    function wireAll() {
      document.querySelectorAll('.fstats').forEach((section) => {
        if (section._fstatsObserved) return;
        section._fstatsObserved = true;

        if (!('IntersectionObserver' in window)) {
          activate(section);
          return;
        }
        const obs = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              activate(entry.target);
              obs.unobserve(entry.target);
            }
          });
        }, { threshold: 0.25 });
        obs.observe(section);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', wireAll);
    } else {
      wireAll();
    }
    new MutationObserver(wireAll).observe(document.body, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zigzag-rows"] && !Shopify.designMode) return;
  try {
    
  /*
   * Force-play any .zigzag__video when it enters the viewport.
   * Browsers can silently block autoplay even with the autoplay+muted
   * attributes; calling .play() explicitly on intersection is the most
   * reliable trigger. Pauses again when scrolled out to save battery.
   */
  (function () {
    if (window.__zigzagVideoInit) return;
    window.__zigzagVideoInit = true;

    function tryPlay(video) {
      if (!video) return;
      video.muted = true;
      const p = video.play();
      if (p && typeof p.catch === 'function') p.catch(() => {});
    }

    if (!('IntersectionObserver' in window)) {
      // Older browser fallback: just attempt play on every video on page load.
      document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('.zigzag__video').forEach(tryPlay);
      });
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          tryPlay(video);
        } else if (!video.paused) {
          video.pause();
        }
      });
    }, { threshold: 0.25 });

    function wireAll() {
      document.querySelectorAll('.zigzag__video').forEach((video) => {
        if (video.dataset.zigzagWired) return;
        video.dataset.zigzagWired = 'true';
        observer.observe(video);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', wireAll);
    } else {
      wireAll();
    }
    new MutationObserver(wireAll).observe(document.body, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
